export * from './lib/pages/partners/mocks/index';
export * from './lib/pages/partners/models/index';
export * from './lib/pages/partners/partners.component';
export * from './lib/pages/partners/partners.module';
